import React from "react";
import { useLanguage } from "../LanguageContext";

const ProductUnique = () => {
  const { language } = useLanguage();
  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading">
          {language === "en"
            ? "Unique Products"
            : "สินค้าเฉพาะทาง (Unique Products)"}
        </h2>
        <p className="description">
          {language === "en" ? (
            <>
              At Proscope, we specialize in delivering{" "}
              <strong>unique and niche IT products</strong> that are not
              commonly found in traditional enterprise catalogs. These include
              specialized tools in areas like{" "}
              <strong>
                data analytics, automation, cybersecurity, and IT asset
                intelligence
              </strong>
              .
              <br />
            </>
          ) : (
            <>
              ที่ Proscope เราคัดสรรผลิตภัณฑ์เฉพาะทางและนวัตกรรมใหม่ ๆ
              ที่ไม่พบได้ง่ายในตลาดทั่วไป
              เพื่อรองรับความต้องการเฉพาะขององค์กรในด้านต่าง ๆ เช่น 
              <strong>
                {" "}
                การวิเคราะห์ข้อมูล (Data Analytics), ระบบอัตโนมัติ (Automation),
                ความปลอดภัยทางไซเบอร์ (Cybersecurity), และ
                การบริหารสินทรัพย์ไอที (IT Asset Intelligence)
              </strong>
              .
              <br />
            </>
          )}
        </p>
        <p className="description">
          {language === "en"
            ? `
          As a trusted system integrator, we partner with emerging technology
          vendors to offer these exclusive solutions — backed by our certified
          engineering and consulting teams who ensure proper deployment and
          support.`
            : `เราทำงานร่วมกับพันธมิตรเทคโนโลยีที่กำลังเติบโตจากทั่วโลก เพื่อส่งมอบโซลูชันเฉพาะทางที่แตกต่าง พร้อมบริการให้คำปรึกษา ออกแบบ และติดตั้งโดยทีมวิศวกรที่ได้รับการรับรองของเรา`}
        </p>
        <p className="description">
          {language === "en" ? (
            <>
              <br />
              If you're looking for something specific and can't find it among
              these brands, please don’t hesitate to contact us.
              <strong>
                We're happy to help identify and provide alternative or emerging
                solutions tailored to your needs.
              </strong>
            </>
          ) : (
            <>
              <br />
              หากคุณกำลังมองหาผลิตภัณฑ์เฉพาะทาง และไม่พบแบรนด์ที่ต้องการในรายการ
              กรุณาติดต่อเรา —
              <br />
              <strong>
                เรายินดีแนะนำทางเลือกหรือโซลูชันที่เหมาะสมสำหรับคุณโดยเฉพาะ
              </strong>
            </>
          )}
        </p>

        <div className="horizontal-text-container">
          <p>Unique Products</p>
          <p>/</p>
          <p>Unique Products</p>
        </div>
      </div>
    </div>
  );
};

export default ProductUnique;
